// skipcq: JS-W1028, JS-0128
import React from 'react';
import { Link } from 'react-router-dom';
import {
  CardContent,
  CardActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import useCrawlerFailures from '../../hooks/useCrawlerFailures';
import DashboardSurfaceCard from './DashboardSurfaceCard';

function DataIssuesCard() {
  const { counts, loading, error } = useCrawlerFailures();

  return (
    <DashboardSurfaceCard>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          Crawler Data Issues
        </Typography>
        <Typography variant="body2" paragraph sx={{
          color: "text.secondary"
        }}>
          Monitor crawler failures and data quality
        </Typography>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 2
            }}>
            <CircularProgress size={24} />
          </Box>
        ) : error ? (
          <Typography variant="body2" color="error">
            Error loading data
          </Typography>
        ) : (
          <>
            <Typography variant="h4" component="div" sx={{
              color: "warning.main"
            }}>
              {counts.total.toLocaleString()}
            </Typography>
            <Typography variant="body2" sx={{
              color: "text.secondary"
            }}>
              Active issues
            </Typography>
            <Typography
              variant="h5"
              component="div"
              color="secondary"
              sx={{ mt: 1 }}
            >
              {counts.pending.toLocaleString()}
            </Typography>
            <Typography variant="body2" sx={{
              color: "text.secondary"
            }}>
              Pending
            </Typography>
            <Typography
              variant="h5"
              component="div"
              sx={{
                color: "info.main",
                mt: 1
              }}>
              {counts.investigated.toLocaleString()}
            </Typography>
            <Typography variant="body2" sx={{
              color: "text.secondary"
            }}>
              Investigated
            </Typography>
          </>
        )}
      </CardContent>
      <CardActions>
        <Button variant="outlined" component={Link} to="/failures" fullWidth>
          View Issues
        </Button>
      </CardActions>
    </DashboardSurfaceCard>
  );
}

export default DataIssuesCard;
